(function ($) {
	// On Dom Ready
	$(function () {
		// Accordion
		$(".the-accordion").each(function (index, element) {
			$(this)
				.find(".accordion-heading")
				.not('.no-content')
				.on("click", function (e) {
					// check if current element is a link
					if ($(e.target).closest("a").length) {
						return;
					}

					e.preventDefault();
					$(this).toggleClass("active");
					$(this).next().slideToggle();
				});
		});
	});
})(jQuery);
